import * as React from 'react';
import { TileViewProps } from './types';
import { FlexValidation } from 'ui';

export const TileViewValidationSummary:React.FC<TileViewProps> = props => {
  const { validation } = props;
  return <FlexValidation {...validation}/>;
};
